import React, { useEffect, createContext, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const TokenContext = createContext();


const AppWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isTokenInvalid, setIsTokenInvalid] = useState(false);

  useEffect(() => {
    const checkTokenValidity = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/check-token`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const data = await response.json();
            if (!data.valid) {
              // Token is invalid or expired
                localStorage.removeItem("token");
                window.location.reload(); 
            }
          } else {
            // Handle invalid response
            localStorage.removeItem("token");
            window.location.reload();
          }
        } catch (error) {
          console.error("Error validating token:", error);
          localStorage.removeItem("token");
          window.location.reload();
        }
      } else {
        setIsTokenInvalid(true); // Token is missing
      }
    };

    checkTokenValidity();
  }, [location.pathname, navigate]);

  return (
    <TokenContext.Provider value={{ isTokenInvalid }}>
      {children}
    </TokenContext.Provider>
  );
};

export default AppWrapper;
